/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
// This file is autogenerated by scripts/build-registry.ts
// Do not edit this file directly.

import React from "react";

export const Index: Record<string, any> = {
  "utils": {
    name: "utils",
    description: "",
    type: "registry:lib",
    files: [{
      path: "src/registry/src/lib/utils.ts",
      type: "registry:lib",
    }],
  },
  "use-controllable-state": {
    name: "use-controllable-state",
    description: "",
    type: "registry:hook",
    files: [{
      path: "src/registry/src/hooks/use-layout-effect.tsx",
      type: "registry:hook",
    },{
      path: "src/registry/src/hooks/use-controllable-state.ts",
      type: "registry:hook",
    }],
  },
  "theme-switcher": {
    name: "theme-switcher",
    description: "A theme switcher component for Next.js apps with next-themes and Tailwind CSS, supporting system, light, and dark modes.",
    type: "registry:component",
    files: [{
      path: "src/registry/theme-switcher/theme-switcher.tsx",
      type: "registry:component",
    }],
  },
  "flip-sentences": {
    name: "flip-sentences",
    description: "",
    type: "registry:component",
    files: [{
      path: "src/registry/flip-sentences/flip-sentences.tsx",
      type: "registry:component",
    }],
  },
  "apple-hello-effect": {
    name: "apple-hello-effect",
    description: "Create a Xin chào and Hello writing effect inspired by Apple using Motion for React.",
    type: "registry:component",
    files: [{
      path: "src/registry/apple-hello-effect/apple-hello-effect.tsx",
      type: "registry:component",
    }],
  },
  "wheel-picker": {
    name: "wheel-picker",
    description: "iOS-like wheel picker for React with smooth inertia scrolling and infinite loop support.",
    type: "registry:component",
    files: [{
      path: "src/registry/wheel-picker/wheel-picker.tsx",
      type: "registry:component",
    }],
  },
  "work-experience": {
    name: "work-experience",
    description: "Displays a list of work experiences with role details and durations.",
    type: "registry:component",
    files: [{
      path: "src/registry/work-experience/work-experience.tsx",
      type: "registry:component",
    }],
  },
  "apple-hello-effect-vi-demo": {
    name: "apple-hello-effect-vi-demo",
    description: "",
    type: "registry:example",
    files: [{
      path: "src/registry/examples/apple-hello-effect-vi-demo.tsx",
      type: "registry:example",
    }],
    component: React.lazy(() => import("@/registry/examples/apple-hello-effect-vi-demo.tsx")),
  },
  "apple-hello-effect-en-demo": {
    name: "apple-hello-effect-en-demo",
    description: "",
    type: "registry:example",
    files: [{
      path: "src/registry/examples/apple-hello-effect-en-demo.tsx",
      type: "registry:example",
    }],
    component: React.lazy(() => import("@/registry/examples/apple-hello-effect-en-demo.tsx")),
  },
  "theme-switcher-demo": {
    name: "theme-switcher-demo",
    description: "",
    type: "registry:example",
    files: [{
      path: "src/registry/examples/theme-switcher-demo.tsx",
      type: "registry:example",
    }],
    component: React.lazy(() => import("@/registry/examples/theme-switcher-demo.tsx")),
  },
  "wheel-picker-demo": {
    name: "wheel-picker-demo",
    description: "",
    type: "registry:example",
    files: [{
      path: "src/registry/examples/wheel-picker-demo.tsx",
      type: "registry:example",
    }],
    component: React.lazy(() => import("@/registry/examples/wheel-picker-demo.tsx")),
  },
  "wheel-picker-form-demo": {
    name: "wheel-picker-form-demo",
    description: "",
    type: "registry:example",
    files: [{
      path: "src/registry/examples/wheel-picker-form-demo.tsx",
      type: "registry:example",
    }],
    component: React.lazy(() => import("@/registry/examples/wheel-picker-form-demo.tsx")),
  },
  "work-experience-demo": {
    name: "work-experience-demo",
    description: "",
    type: "registry:example",
    files: [{
      path: "src/registry/examples/work-experience-demo.tsx",
      type: "registry:example",
    }],
    component: React.lazy(() => import("@/registry/examples/work-experience-demo.tsx")),
  },
}